export default __webpack_public_path__ + "static/media/MapoDPPA.c32d66f2.woff";